import { render, staticRenderFns } from "./CoreBPPolicyHeader.html?vue&type=template&id=9ac260fe&external"
import script from "./CoreBPPolicyHeader.vue?vue&type=script&lang=js"
export * from "./CoreBPPolicyHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports